// AUTO-GENERATED by scripts/write-build-info.mjs — DO NOT EDIT BY HAND.
// Regenerated on every vite build (web) and wrangler deploy (worker) so each
// deployed artifact carries a unique identifier surfaced via /health, the
// launch-screen footer, and structured startup logs.
export const BUILD_INFO = {
  version: "1.1.1",
  commitHash: "a296ab4db61f",
  buildTime: "2026-04-13T12:41:45.325Z",
} as const

export type BuildInfo = typeof BUILD_INFO
